<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
*{
  margin: 0;
  padding: 0;
}
#app {
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-family: Microsoft YaHei;
  /* text-align: center; */
  color: #2c3e50;
    height:100%;
  /* margin-top: 60px; */
}
body,html {
  margin:0;
  height: 100%;
}
* {
  margin: 0;
  padding: 0;

}
li {
  list-style: none;
}

.pulse {
        animation-name: pulse;
        animation-iteration-count: infinite;
        -webkit-animation-duration: 1s;
        animation-duration: 1s;
        -webkit-animation-fill-mode: both;
        animation-fill-mode: both;
      }
      @keyframes pulse {
        from {
          transform: scale3d(1, 1, 1);
        }
      
        50% {
          transform: scale3d(1.1, 1.1, 1.1);
        }
      
        100% {
          transform: scale3d(1, 1, 1);
          /* transform: scale3d(1.08, 1.08, 1.08); */
        }
      }

.up2 {
	opacity: 0;
	-webkit-animation: bounceInUp 1.5s ease forwards;
	animation: bounceInUp 1.5s ease forwards;
	-webkit-animation-delay: 1s;
}

@keyframes bounceInUp {
  from, 60%, 90%, to {
    -webkit-animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
    animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
  }

  from {
    opacity: 0;
    -webkit-transform: translate3d(0, 2000px, 0);
    transform: translate3d(0, 2000px, 0);
  }

  60% {
    opacity: 1;
    -webkit-transform: translate3d(0, -20px, 0);
    transform: translate3d(0, -20px, 0);
  }


  90% {
    -webkit-transform: translate3d(0, -5px, 0);
    transform: translate3d(0, -5px, 0);
  }

  to {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}

.ani_top {
	opacity: 0;
	-webkit-animation: bounceInUp 1.5s ease forwards;
	animation: bounceInUp 1.5s ease forwards;
	-webkit-animation-delay: 1s;
}

@keyframes bounceInUp {
  from, 60%, 90%, to {
    -webkit-animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
    animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
  }

  from {
    opacity: 0;
    -webkit-transform: translate3d(0, -1000px, 0);
    transform: translate3d(0, -1000px, 0);
  }

  60% {
    opacity: 1;
    -webkit-transform: translate3d(0, -20px, 0);
    transform: translate3d(0, -20px, 0);
  }


  90% {
    -webkit-transform: translate3d(0, -5px, 0);
    transform: translate3d(0, -5px, 0);
  }

  to {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}
.ani_left{
    opacity: 0;
		position: relative;
		animation: bounceInLeft 2s linear forwards;
		-webkit-animation: bounceInLeft 2s linear forwards;
}

.ani_right{
  opacity: 0;
	position: relative;
	animation: bounceInRight 2s linear forwards;
	-webkit-animation: bounceInRight 2s linear forwards;
}

@-webkit-keyframes bounceInRight {
  from, 60%, 75%, 90%, to {
    -webkit-animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
    animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
  }

  0% {
    opacity: 0;
    -webkit-transform: translate3d(2000px, 0, 0);
    transform: translate3d(2000px, 0, 0);
  }

  60% {
    opacity: 1;
    -webkit-transform: translate3d(25px, 0, 0);
    transform: translate3d(25px, 0, 0);
  }

  75% {
    -webkit-transform: translate3d(-10px, 0, 0);
    transform: translate3d(-10px, 0, 0);
  }

  90% {
    -webkit-transform: translate3d(5px, 0, 0);
    transform: translate3d(5px, 0, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}

@-webkit-keyframes bounceInLeft {
  from, 60%, 75%, 90%, to {
    -webkit-animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
    animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
  }

  0% {
    opacity: 0;
    -webkit-transform: translate3d(-2000px, 0, 0);
    transform: translate3d(-2000px, 0, 0);
  }

  60% {
    opacity: 1;
    -webkit-transform: translate3d(25px, 0, 0);
    transform: translate3d(25px, 0, 0);
  }

  75% {
    -webkit-transform: translate3d(-10px, 0, 0);
    transform: translate3d(-10px, 0, 0);
  }

  90% {
    -webkit-transform: translate3d(5px, 0, 0);
    transform: translate3d(5px, 0, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}

.swiperList .swiper-wrapper{
  padding-left:60px;
   padding-right:60px;
}
.swiperPrpduct .swiper-button-prev, .swiperPrpduct  .swiper-container-rtl .swiper-button-next{
  background: url(https://grammar.oss-cn-qingdao.aliyuncs.com/online/image/notework/assets/product/left.png) no-repeat;
  background-size: 100% 100%;
  width:32px;
  height:65px;
  left: 0.1403rem;
}
.swiperPrpduct .swiper-button-next, .swiperPrpduct  .swiper-container-rtl .swiper-button-prev{
  background: url(https://grammar.oss-cn-qingdao.aliyuncs.com/online/image/notework/assets/product/right.png) no-repeat;
  background-size: 100% 100%;
  width:32px;
  height:65px;
  right: -0.005rem;
}
.swiperPrpduct .swiper-button-prev, .swiperPrpduct .swiper-button-next{
  top:44%;
}
.model8 .el-carousel__arrow{
 opacity:0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue